<template>
  <div>
    <TreasurersChecksReportComp />
  </div>
</template>

<script>
import TreasurersChecksReportComp from '@/components/Gl/TreasurersChecks/Reports/TreasurersChecksReportComp.vue';

export default {
  name: 'TreasurersChecksReports',
  components: {
    TreasurersChecksReportComp,
  },
};
</script>
